import l10n from './l10n';

/**
 * Turns an error object into a LocaleString.
 * @param {object} err Error object such as an ResError.
 * @returns {LocaleString} Locale string.
 */
export default function errorToLocaleString(err) {
	if (typeof err != 'object' || err === null || !(err.code && err.message)) {
		try {
			if (err instanceof Error) {
				console.error(err);
			}
			return l10n.isLocaleString(err)
				? err
				: l10n.l('system.unknownErrorMsg', "Okänt fel: {msg}", { msg: typeof err.toString == 'function'
					? err.toString()
					: JSON.stringify(err)
				});
		} catch (ex) {
			console.log("error stringifying errorToLocaleString error: ", err);
			return l10n.l('system.unknownError', "Okänt fel");
		}
	}
	return l10n.l(err.code, err.message, err.data);
}
